module.exports = __webpack_public_path__ + "static/media/icn_mainnav_discover_light.5a67e051.svg";